import React, { useEffect, useState } from "react";
import { useLocation } from "react-router";
import { getRetailersById } from "../../../apis/retailers";

const ViewRetailer = () => {
  const [formlist, setFormList] = useState(null);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const rawData = queryParams.get("retailer_id");

  useEffect(() => {
    const fetchNationalDetails = async () => {
      try {
        const response = await getRetailersById(rawData);
        setFormList(response?.data || {});
      } catch (error) {
        console.error("Failed to fetch national details", error);
      }
    };
    fetchNationalDetails();
  }, [rawData]);

  const parsedAddress = JSON.parse(formlist?.address || "{}");

  const fields = [
    { label: "Full Name", value: formlist?.full_name, icon: "fa-user" },
    { label: "Email", value: formlist?.email, icon: "fa-envelope" },
    { label: "Phone Number", value: formlist?.phone_number, icon: "fa-phone" },
    {
      label: "Company Name",
      value: formlist?.company_name,
      icon: "fa-building",
    },
    { label: "GST Number", value: formlist?.gst_number, icon: "fa-building" },
    {
      label: "Address",
      value: parsedAddress?.addressLine,
      icon: "fa-map-marker-alt",
    },
    { label: "City", value: parsedAddress?.city, icon: "fa-map-marker-alt" },
    { label: "State", value: parsedAddress?.states, icon: "fa-map-marker-alt" },
    {
      label: "Country",
      value: parsedAddress?.country,
      icon: "fa-map-marker-alt",
    },
    {
      label: "Pincode",
      value: parsedAddress?.pincode,
      icon: "fa-map-marker-alt",
    },
    { label: "Username", value: formlist?.user?.username, icon: "fa-user" },
    { label: "Owner Name", value: "Financer", icon: "fa-user" },
    {
      label: "Parent Name",
      value: formlist?.financer?.company_name,
      icon: "fa-user",
    },
  ];

  return (
    <div className="page-wrapper">
      <div className="content">
        {formlist && (
          <div className="card shadow-sm rounded-3 border-0">
            <div className="card-header bg-primary text-white py-3">
              <h2 className="mb-0 text-center text-white">
                {formlist.company_name}
              </h2>
            </div>
            <div className="card-body p-4">
              <div className="row g-4">
                {fields.map((field, index) => (
                  <div key={index} className="col-md-6">
                    <p className="info">
                      <span className="info-label">
                        <i className={`fas ${field.icon}`}></i> {field.label} :
                      </span>
                      <span className="info-value">
                        {" "}
                        {field.value || "N/A"}
                      </span>
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ViewRetailer;
